import { render } from "./PromoPopup.vue?vue&type=template&id=42553e72&scoped=true"
import script from "./PromoPopup.vue?vue&type=script&lang=js"
export * from "./PromoPopup.vue?vue&type=script&lang=js"

import "./PromoPopup.vue?vue&type=style&index=0&id=42553e72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42553e72"]])

export default __exports__